// scheduling/components/HoursByStaffPopover.jsx
// A clickable hours value that reveals a by-staff breakdown popover — the same
// detail the JobProgressBar segments show, but for contexts that have no bar
// (e.g. a no-budget job's "WIP logged / scheduled" line in the Jobs-view detail
// panel). Self-contained open state + outside-click close so instances coexist.
import { useState, useRef, useEffect } from 'react';

export default function HoursByStaffPopover({
  label,
  hours = 0,
  byStaff = [],
  align = 'left',          // which edge the popover hangs from ('left' | 'right')
  accent = '#93C5FD',      // header color inside the dark popover
  emptyText = 'No detail',
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const rounded = Math.round((hours || 0) * 100) / 100;
  return (
    <span ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <span
        onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}
        style={{ cursor: 'pointer', color: '#356371', textDecoration: 'underline dotted', textUnderlineOffset: 2 }}
        title={`${label} — by staff`}
      >
        {rounded}h {label}
      </span>
      {open && (
        <div style={{
          position: 'absolute', top: 20, [align]: 0, background: '#1F2937', color: '#fff',
          borderRadius: 8, padding: '10px 14px', fontSize: 11, whiteSpace: 'nowrap', zIndex: 100,
          boxShadow: '0 4px 16px rgba(0,0,0,0.25)', minWidth: 150,
        }}>
          <div style={{ fontWeight: 700, marginBottom: 4, color: accent }}>{label} ({rounded}h)</div>
          {byStaff.length > 0 ? byStaff.map((s, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 16, padding: '1px 0' }}>
              <span>{s.name}</span><span style={{ fontWeight: 600 }}>{Math.round((s.hours || 0) * 100) / 100}h</span>
            </div>
          )) : <div style={{ color: '#9CA3AF', fontStyle: 'italic' }}>{emptyText}</div>}
        </div>
      )}
    </span>
  );
}
